/**
 * ProjectUserEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { ProjectUserRoleEntity } from "../ProjectUserRoleEntity";
import { ProjectUserRightEntity } from "../ProjectUserRightEntity";
import { VisitEntity } from "../VisitEntity";
import { PlanningEventLogEntity } from "../PlanningEventLogEntity";
import { CalendarModificationEntity } from "../CalendarModificationEntity";
import { BugNoteEntity } from "../BugNoteEntity";
import { DocumentVersionEntity } from "../DocumentVersionEntity";
import { ReportEntity } from "../ReportEntity";
import { ProjectUserEntity } from "../ProjectUserEntity";
declare global {
    interface EntityTypeMap {
        ProjectUser: ProjectUserEntity;
    }
}
export abstract class ProjectUserGeneratedEntity extends BaseEntity {
    public abstract projectUserId: string;
    public abstract templateId: string | null;
    public abstract cloudUserId: string;
    public abstract email: string;
    public abstract name: string | null;
    public abstract company: string | null;
    public abstract project: ProjectEntity;
    public abstract role: ProjectUserRoleEntity | null;
    public abstract right: ProjectUserRightEntity | null;
    public abstract ownerOfProject: ProjectEntity | null;
    public abstract readonly visits: ReadonlyArray<VisitEntity>;
    public abstract readonly planningEventLogs: ReadonlyArray<PlanningEventLogEntity>;
    public abstract readonly calendarModifications: ReadonlyArray<CalendarModificationEntity>;
    public abstract readonly bugNotes: ReadonlyArray<BugNoteEntity>;
    public abstract readonly documentVersions: ReadonlyArray<DocumentVersionEntity>;
    public abstract readonly reports: ReadonlyArray<ReportEntity>;
}
